import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Create = () => {

    const {addData} = useEntityCrud('Guild/SetGuilds');
    const {addData: addSubData} = useEntityCrud('Guild/SetSubGuilds');
    const navigate = useNavigate();

    const initialValues = {
        title: '',
        guildId: ''
    };
    
    const validationSchema = Yup.object({
        title: Yup.string()
        .required()
    });
    
    const onSubmit = (values) => {
         
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            title: values.title
        };
        if(values.icon)
            postedData.iconData = values.icon.split('base64,')[1];
        if(values.guildId != ''){
            postedData.guildId = values.guildId;
            addSubData(postedData).then(({data}) => {
                if(data.status){
                    toast.success('صنف جدید با موفقیت ایجاد شد');
                    return navigate('/guilds/sub-guilds/' + postedData.guildId);
                }else
                    data.errors.map(error => toast.error(error.message));
            }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
        }else{
            addData(postedData).then(({data}) => {
                if(data.status){
                    toast.success('صنف جدید با موفقیت ایجاد شد');
                    return navigate('/guilds');
                }else
                    data.errors.map(error => toast.error(error.message));
            }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/guilds',{replace: true});
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد صنف جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Create;